import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ListValues, FormInputConfig, AllInputTypes } from '../../../../../trash/shared/interfaces/form-input-config';
import { ICreateDistrictRequest, IDistrictResponse } from '../dtos';
import { patterns } from '../../../../../lib/formly/patterns';

export class CreateDistrictModel implements ICreateDistrictRequest {
  referenceId: number;
  englishName: string;
  arabicName: string;
  isActive: boolean | undefined;
  cityId: string;
  postalCode: string;
  latitude?: number;
  longitude?: number;

  constructor(request: ICreateDistrictRequest) {
    this.referenceId = request.referenceId;
    this.englishName = request.englishName;
    this.arabicName = request.arabicName;
    this.isActive = request.isActive;
    this.cityId = request.cityId;
    this.postalCode = request.postalCode;
    this.latitude = request.latitude;
    this.longitude = request.longitude;
  }

  static create(data: ICreateDistrictRequest): CreateDistrictModel {
    return new CreateDistrictModel(data);
  }

  static createDefault(): CreateDistrictModel {
    return CreateDistrictModel.create({
      referenceId: 0,
      englishName: '',
      arabicName: '',
      isActive: true,
      cityId: '',
      postalCode: ''
    });
  }

  static createFromItem(item: IDistrictResponse): CreateDistrictModel {
    return new CreateDistrictModel({
      referenceId: item.referenceId,
      englishName: item.englishName,
      arabicName: item.arabicName,
      isActive: item.isActive,
      cityId: item.city.id,
      latitude: item.latitude,
      longitude: item.longitude,
      postalCode: item.postalCode
    });
  }

  getFormConfig(cities: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      // getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'englishName',
        label: translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ENGLISH_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ENGLISH_NAME')}`,
        defaultValue: this.englishName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ENGLISH_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyEnglishCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ENGLISH'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'arabicName',
        label: translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ARABIC_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ARABIC_NAME')}`,
        defaultValue: this.arabicName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.DISTRICT_ARABIC_NAME')}`
          },
          {
            function: Validators.pattern(patterns.onlyArabicCharacters),
            errorMessage: translate?.instant('SERVICE_MANAGEMENT.VALIDATION_ONLY_ARABIC'),
            errorName: 'pattern'
          }
        ]
      },
      {
        type: AllInputTypes.Select,
        name: 'cityId',
        label: translate?.instant('LOCATION_MANAGEMENT.CITY_NAME'),
        placeholder: translate?.instant('GENERAL.SELECT'),
        widthClass: 'col-12',
        defaultValue: this.cityId,
        isDisable: !isVisible,
        listValues: cities,
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_SELECT')} ${translate?.instant('LOCATION_MANAGEMENT.CITY_NAME')}`
          }
        ]
      },
      // {
      //   type: AllInputTypes.Text,
      //   name: 'postalCode',
      //   label: translate?.instant('LOCATION_MANAGEMENT.POSTAL_CODE'),
      //   placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.POSTAL_CODE')}`,
      //   defaultValue: this.postalCode,
      //   isDisable: !isVisible,
      //   widthClass: 'col-12',
      //   validation: [
      //     {
      //       function: Validators.required,
      //       errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('LOCATION_MANAGEMENT.POSTAL_CODE')}`
      //     }
      //   ]
      // },
      // {
      //   type: AllInputTypes.Number,
      //   name: 'latitude',
      //   label: translate?.instant('LOCATION_MANAGEMENT.LATITUDE'),
      //   placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.LATITUDE')}`,
      //   defaultValue: this.latitude,
      //   isDisable: !isVisible,
      //   widthClass: 'col-12'
      // },
      // {
      //   type: AllInputTypes.Number,
      //   name: 'longitude',
      //   label: translate?.instant('LOCATION_MANAGEMENT.LONGITUDE'),
      //   placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('LOCATION_MANAGEMENT.LONGITUDE')}`,
      //   defaultValue: this.longitude,
      //   isDisable: !isVisible,
      //   widthClass: 'col-12'
      // },
      {
        type: AllInputTypes.ToggleButton,
        name: 'isActive',
        label: translate?.instant('GENERAL.STATUS'),
        defaultValue: this.isActive ?? true,
        isDisable: !isVisible,
        widthClass: 'col-12'
      }
    ];
  }
}
